import React from 'react';

const storyMeta = [
  {
    emoji: '⚡',
    accentBorder: 'border-cyan-500/50',
    accentBg: 'from-cyan-500/20 to-cyan-900/5',
    glow: 'hover:shadow-cyan-500/15',
    tag: 'Health & Performance',
  },
  {
    emoji: '💪',
    accentBorder: 'border-orange-500/50',
    accentBg: 'from-orange-500/20 to-orange-900/5',
    glow: 'hover:shadow-orange-500/15',
    tag: 'Fitness',
  },
  {
    emoji: '⚽',
    accentBorder: 'border-blue-500/50',
    accentBg: 'from-blue-500/20 to-blue-900/5',
    glow: 'hover:shadow-blue-500/15',
    tag: 'Sport & Culture',
  },
  {
    emoji: '📚',
    accentBorder: 'border-purple-500/50',
    accentBg: 'from-purple-500/20 to-purple-900/5',
    glow: 'hover:shadow-purple-500/15',
    tag: 'Lifelong Learning',
  },
  {
    emoji: '🌍',
    accentBorder: 'border-emerald-500/50',
    accentBg: 'from-emerald-500/20 to-emerald-900/5',
    glow: 'hover:shadow-emerald-500/15',
    tag: 'Travel & Growth',
  },
];

const LifeAndInterests = ({ lifeStories }) => {
  if (!lifeStories || lifeStories.length === 0) return null;

  return (
    <section id="life-and-interests" className="w-full" data-aos="fade-up">

      {/* Section Header */}
      <div className="text-center mb-16">
        <p className="section-eyebrow">Beyond the code</p>
        <h2 className="section-heading">Life &amp; Interests</h2>
        <div className="section-divider" />
        <p className="dark:text-slate-400 text-slate-600 text-sm mt-4 max-w-xl mx-auto">
          The experiences, challenges, and obsessions that shape who I am outside of work.
        </p>
      </div>

      {/* Zig-zag stack */}
      <div className="flex flex-col gap-6">
        {lifeStories.map((item, i) => {
          const meta = storyMeta[i] ?? storyMeta[0];
          const isEven = i % 2 === 0;

          return (
            <div
              key={i}
              className={`group flex ${isEven ? 'flex-row' : 'flex-row-reverse'}
                rounded-2xl overflow-hidden border ${meta.accentBorder}
                dark:bg-[#0e0c29]/60 bg-white
                hover:shadow-2xl ${meta.glow}
                hover:-translate-y-1 transition-all duration-500
                ${isEven ? 'lg:mr-[10%]' : 'lg:ml-[10%]'}`}
              data-aos={isEven ? 'fade-right' : 'fade-left'}
              data-aos-delay={i * 100}
            >
              {/* Visual panel */}
              <div className={`relative flex-shrink-0 w-52 md:w-64 flex items-center justify-center
                bg-gradient-to-br ${meta.accentBg} overflow-hidden`}>

                {/* Photo on hover */}
                {item.image && (
                  <img
                    src={item.image}
                    alt={item.title}
                    loading="lazy"
                    className="absolute inset-0 w-full h-full object-cover
                      opacity-0 group-hover:opacity-100 scale-110 group-hover:scale-100
                      transition-all duration-700"
                  />
                )}

                <span className={`text-7xl select-none z-10 transition-all duration-500
                  ${item.image ? 'group-hover:opacity-0 group-hover:scale-150' : 'group-hover:scale-110'}`}>
                  {meta.emoji}
                </span>
              </div>

              {/* Text panel */}
              <div className="flex-1 flex flex-col justify-center px-8 py-8 gap-4">
                <span className={`text-xs font-semibold uppercase tracking-widest
                  ${meta.accentBorder.replace('border-', 'text-').replace('/50', '')}`}>
                  {meta.tag}
                </span>
                <h3 className="text-xl md:text-2xl font-bold dark:text-white text-slate-900 leading-snug">
                  {item.title}
                </h3>
                <p className="text-sm md:text-base dark:text-slate-300 text-slate-600 leading-relaxed">
                  {item.description}
                </p>
              </div>
            </div>
          );
        })}
      </div>

    </section>
  );
};

export default LifeAndInterests;
